import { render, staticRenderFns } from "./record-detail-table.vue?vue&type=template&id=ad3e754e"
import script from "./record-detail-table.vue?vue&type=script&lang=js"
export * from "./record-detail-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports